import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/ITTSRepository').ITTSRepository} */
export class TTSRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async textToSpeech(voiceId, request, options = {}) {
    const params = this._buildParams(options);
    return this.client.postAudio(ENDPOINTS.TTS.SPEECH(voiceId), request, { params });
  }

  async streamTextToSpeech(voiceId, request, options = {}) {
    const params = this._buildParams(options);
    return this.client.postStream(ENDPOINTS.TTS.STREAM(voiceId), request, { params });
  }

  _buildParams(options) {
    const params = {};
    if (options.enableLogging !== undefined) params.enable_logging = options.enableLogging;
    if (options.optimizeStreamingLatency !== undefined) params.optimize_streaming_latency = options.optimizeStreamingLatency;
    if (options.outputFormat !== undefined) params.output_format = options.outputFormat;
    return params;
  }
}
